import { Link as RouterLink, type LinkProps } from "react-router-dom";
import { forwardRef } from "react";
import { useLanguage } from "@/lib/i18n/LanguageContext";
import { localizePathname } from "@/hooks/useLocalePath";

/**
 * A wrapper around React Router's Link that automatically adds
 * the current language prefix to internal paths.
 */
export const LocalizedLink = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ to, ...props }, ref) => {
    const { language } = useLanguage();

    if (typeof to === 'string') {
      return <RouterLink ref={ref} to={localizePathname(to, language)} {...props} />;
    }

    if (typeof to === 'object' && to.pathname) {
      return (
        <RouterLink
          ref={ref}
          to={{ ...to, pathname: localizePathname(to.pathname, language) }}
          {...props}
        />
      );
    }

    return <RouterLink ref={ref} to={to} {...props} />;
  }
);

LocalizedLink.displayName = 'LocalizedLink';
